import { Injectable } from '@angular/core';
import { AuthService } from '../login/auth.service';

@Injectable({
    providedIn: 'root',
})
export class LocalStorageService {
    constructor(private authService: AuthService) {}

    initStorage() {
        this.initToken();
    }

    initToken() {
        const token = this.authService.getToken();
        if (token) {
            this.authService.setToken(token);
        }
    }

    getDocument() {
        return localStorage.getItem('print-document');
    }

    storeDocument(document: string) {
        return localStorage.setItem('print-document', document);
    }

    removeDocument() {
        return localStorage.removeItem('print-document');
    }
}
